import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, extendObservable } from 'mobx';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';

@injectIntl
@observer
export default class UserSelect extends React.Component {
  static defaultProps = {
    showKey: 'name'
  }

  constructor(props) {
    super(props);

    let value;
    if (props.value) {
      if (props.multi) {
        value = props.value.map(user => ({ value: user, label: user[this.props.showKey] }));
      } else {
        value = { value: props.value, label: props.value[this.props.showKey] };
      }
    }

    this.state = {
      selected: value
    };
  }

  render() {
    const {
      users,
      intl,
      onChange,
      onRemove,
      value,
      style,
      isAssigneeSelect,
      ...rest
    } = this.props;

    const options = users.map(user => ({ value: user, label: user[this.props.showKey] }));
    var selected = this.state.selected
      ? rest.multi
        ? this.state.selected
        : this.state.selected.value
      : undefined;

    if (isAssigneeSelect != undefined) {
      var aux;
      if (value) {
        if (rest.multi) {
          aux = value.map(user => ({ value: user, label: user[this.props.showKey] }));
        } else {
          aux = { value: value, label: value[this.props.showKey] };
        }
      }
      selected = aux
    }

    return (
      <Select
        {...rest}
        onChange={this.handleOnChange}
        value={selected}
        options={options}
        valueComponent={this.valueComponent}
        optionRenderer={this.optionRenderer}
        style={{ ...style, ...{ height: '52px' } }}
      />
    );
  }

  handleOnChange = items => {
    const { multi, onChange } = this.props;
    this.setState({ selected: items });

    const selectedUsers = items
      ? multi
        ? items.map(i => i.value)
        : items.value
      : undefined;
    onChange(selectedUsers);
  };

  optionRenderer = option => {
    return (
      <span className="">
        <img
          src={option.value.profilePhotoUrl}
          style={{ width: '30px', borderRadius: '50%', marginRight: '10px' }}
        />
        {option.label}
      </span>
    );
  };

  valueComponent = component => {
    const { multi, onRemove, disabled } = this.props;

    const value = multi ? component.value.value : component.value;
    const style = multi ? {} : { paddingTop: '7px' };
    return (
      <span className="Select-value" style={style}>
        {multi && !disabled && (
          <span
            className="Select-value-icon"
            onClick={() => {
              component.onRemove(component.value);
              if (onRemove) {
                onRemove(component.value.value);
              }
            }}
          >
            x
          </span>
        )}

        <span className="Select-value-label">
          <img
            src={value.profilePhotoUrl}
            style={{ width: '35px', borderRadius: '50%', marginRight: '10px' }}
          />
          {value[this.props.showKey]}
        </span>
      </span>
    );
  };
}

UserSelect.propTypes = {
  users: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func
};
